import React from "react"
import { Link, graphql } from "gatsby"
import styles from "../styles/global.module.scss"
import BackgroundImage from "gatsby-background-image"

// Components
import Layout from "../components/layout/layout"

import { useGetTokens } from "../hooks/useGetTokens"
import convertTokens from "../helpers/convertTokens"
import setSeoData from "../helpers/setSeoData"

export default ({ data, location }) => {
  // Get metadata
  const metadata = useGetTokens()

  const { remodeling_service } = data
  let featuredImage
  if (remodeling_service.frontmatter.featuredImage) {
    featuredImage =
      remodeling_service.frontmatter.featuredImage.childImageSharp.fluid
  }

  let seo_data = setSeoData(remodeling_service.frontmatter)

  return (
    <Layout location={location} seo_data={seo_data}>
      {featuredImage ? (
        <BackgroundImage id={styles.workPageFeatureImg} fluid={featuredImage} />
      ) : null}
      <div className={styles.container}>
        <h1>{remodeling_service.frontmatter.name}</h1>
        <p>{remodeling_service.frontmatter.description}</p>
        <div
          dangerouslySetInnerHTML={{
            __html: convertTokens(remodeling_service.html, metadata),
          }}
        />
        <div className={`${styles.buttonContain}`}>
          <Link
            className={`${styles.btn} ${styles.btnSmall} ${styles.btnLeft}`}
            to={`/request-a-quote/`}
          >
            Request Quote
          </Link>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!) {
    remodeling_service: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        template
        name
        meta {
          title
          description
          page_visible
        }
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        is_active
        is_featured
        tags
      }
    }
  }
`
